import gsap from 'gsap'
import { module } from 'modujs';
import { SplitText } from 'gsap/SplitText.js';
import { shuffle } from '../utils/array';

gsap.registerPlugin(SplitText);

export default class extends module {
    constructor(m) {
        super(m);

        this.$cols = Array.from(this.$('col'))
        this.timelines = {};
    }

    init() {
        if(!this.$cols.length) {
            console.error('[FancyTexts] no cols given')
            return false;
        }

        for(let col of this.$cols) {
            const animations = this.getData('animations', col) ? this.getData('animations', col).split(',') : ['base','stagger','shuffle','scramble','fast']

            let contentIndex = -1;
            let contents = this.getData('contents', col).split('|');
            let rows = this.getData('rows', col);
            if(rows != 'manual') rows = parseInt(rows);

            let tl;
            let populate = (content) => {
                col.innerHTML = '';
                let row = document.createElement('div')
                row.innerText = content;

                if(rows == 'manual') {
                    let sentences = content.split(',');

                    for(let sentence of sentences) {
                        row.innerText = sentence;
                        col.appendChild(row.cloneNode(true))
                    }
                } else {
                    for(let i = 0; i < rows; i++)
                        col.appendChild(row.cloneNode(true))
                }
            }

            let startNextContent = () => {
                contentIndex++;
                const content = contents[contentIndex % contents.length];
                populate(content, 7)

                this.timelines[this.$cols.indexOf(col)] && this.timelines[this.$cols.indexOf(col)].kill?.()
                tl = gsap.timeline({
                    onComplete: () => {
                        gsap.set(col, { opacity: 0 })
                        split.revert()

                        requestAnimationFrame(() => {
                            startNextContent();
                        })
                    }
                });
                this.timelines[this.$cols.indexOf(col)] = tl;



                let split = new SplitText(col, { type: 'chars' });
                tl.set(split.chars, { opacity: 0 })
                tl.set(col, { opacity: 1 })

                const animation = animations[Math.floor(animations.length*Math.random())];
                switch(animation) {
                    case 'base':
                        for(let i = 0; i < col.children.length; i++) {
                            // tl.addLabel('row'+i)
                            tl.set([...col.children[i].children], { opacity: 1, stagger: .04 }, 'row'+i)
                            // if(i>0) tl.set(shuffle([...col.children[i-1].children]), { opacity: 0, stagger: .04 }, 'row'+i)
                        }
                        tl.set(shuffle(Array.from(split.chars)), { opacity: 0, stagger: .04 })
                        tl.add(() => {},'+=1')
                        break;
                    case 'stagger':
                        for(let i = 0; i < col.children.length; i++) {
                            tl.set([...col.children[i].children], { opacity: 1, stagger: .04 }, i*0.1)
                            tl.addLabel(i+'first')

                            if(i>0) {
                                tl.set([...col.children[i-1].children], { opacity: 0, stagger: .04 }, (i-1)+'first')
                            }
                        }
                        break;
                    case 'shuffle':
                        for(let i = 0; i < col.children.length; i++) {
                            tl.set([...col.children[i].children], { opacity: 1, stagger: .04 }, i*0.1)
                            tl.addLabel(i+'out')

                            if(i>0) {
                                tl.set(shuffle([...col.children[i-1].children]), { opacity: 0, stagger: .08 }, (i-1)+'out')
                            }
                        }
                        break;
                    case 'scramble':
                        for(let i = 0; i < col.children.length; i++) {
                            tl.set([...col.children[i].children], { opacity: 1, stagger: .04 })
                            tl.addLabel(i+'out')

                            if(i>0) {
                                tl.add(() => {
                                    let alternateChars = '~!@#$%&*{}/?;;<>[]'.split('')
                                    let chars = shuffle([...col.children[i-1].children]);

                                    for(let j = 0; j < chars.length; j++) {
                                        setTimeout(() => {
                                            chars[j].innerText = alternateChars[Math.floor(alternateChars.length*Math.random())]
                                        }, 200*j);

                                        setTimeout(() => {
                                            gsap.set(chars[j], { opacity: 0 })
                                        }, 400*j);
                                    }
                                }, (i-1)+'out')
                            }
                        }
                        tl.set(shuffle(Array.from(split.chars)), { opacity: 0, stagger: .01 })
                        break;
                    case 'fast':
                        for(let i = 0; i < col.children.length; i++) {
                            // tl.addLabel('row'+i)
                            tl.set([...col.children[i].children], { opacity: 1, stagger: .02 }, 'row'+i)
                            if(i>0) tl.set([...col.children[i-1].children], { opacity: 0, stagger: .02 }, 'row'+i)
                        }
                        break;
                    case 'slow':
                        for(let i = 0; i < col.children.length; i++) {
                            // tl.addLabel('row'+i)
                            tl.set([...col.children[i].children], { opacity: 1, stagger: .1 }, 'row'+i)
                            tl.add(() => {},'row'+i+'+=.5')
                            if(i>0) tl.set(shuffle([...col.children[i-1].children]), { opacity: 0, stagger: .2 }, 'row'+i)
                        }
                        tl.add(() => {},'+=1')
                        break;
                    // case 'offset':
                    //     for(let i = 0; i < col.children.length; i++) {
                    //         tl.set([...col.children[i].children], { opacity: 1, stagger: .04 }, i*0.1)
                    //         tl.addLabel(i+'out')

                    //         if(i>0) {
                    //             tl.add(() => {
                    //                 for(let j = 0;j<col.children[i-1].children.length;j++) {
                    //                     setTimeout(() => {
                    //                         let char = col.children[i-1].children[0]
                    //                         char && col.children[i-1].appendChild(char)
                    //                     }, j*100)
                    //                 }
                    //             }, (i-1)+'out')
                    //             tl.add(() => {}, (i-1)+'out+='+((col.children[i-1].children.length-1)*100))

                    //             // tl.set([...col.children[i-1].children], { onStart: () => {
                    //             //     setInterval(() => {
                    //             //         let char = col.children[j-1].children[0]
                    //             //         char && col.children[j-1].appendChild(char)
                    //             //     }, 100)
                    //             // }, opacity: 1, stagger: .1 }, (i-1)+'out')
                    //         }
                    //     }
                    //     break;
                }
            }

            startNextContent();
        }
    }

    destroy() {
        for(let key of Object.keys(this.timelines)) {
            this.timelines[key] && this.timelines[key].kill?.();
        }
    }
}
